import { api } from './http.api';

export const ssoFinalPath = '/sso/final';

export interface SsoTokenResponse {
  token?: string;
  refresh_token?: string;
  accessToken?: string;
  refreshToken?: string;
}

export const exchangeSsoCode = async (code: string) => api.post<SsoTokenResponse>(ssoFinalPath, { code });

export const parseSsoTokenResponse = (data: SsoTokenResponse) => ({
  accessToken: data.token ?? data.accessToken ?? '',
  refreshToken: data.refresh_token ?? data.refreshToken ?? '',
});

/**
 * Fire-and-forget SSO logout. Outcome (redirects, CORS, errors) is ignored.
 */
export const requestSsoLogout = (logoutPath: string, accessToken: string): void => {
  void api
    .get(logoutPath, {
      headers: { Authorization: `Bearer ${accessToken}` },
      // Redirects and CORS failures here are expected.
      silentError: true,
    })
    .catch(() => undefined);
};
